var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-editor-mode"},[_c('r-text',{staticStyle:{"margin-bottom":"4px"},attrs:{"type":"caption"}},[_vm._v(" Выбор режима ")]),_c('div',{staticClass:"map-editor-mode__buttons"},[_c('r-radio-group',{attrs:{"button-list":_vm.modes,"active":_vm.mode},on:{"change":_vm.toggleEditorMode}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }